import { useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Badge, Text, VStack } from '@chakra-ui/react';
import { Phone } from 'lucide-react';
import SearchAndFiltersSection from '@/components/section/SearchAndFiltersSection';
import PageHeader from '@/components/ui/PageHeader';
import FrontlineSetupDrawer from './FrontlineSetupDrawer';
import Button from '@/components/ui/Button';
import Pagination from '@/components/ui/Pagination';
import EntityTableSection from '@/components/section/EntityTableSection';
import { useFrontlineOrganizationsQuery } from '@/entities/frontline/api';
export default function FrontlinePage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const { organizationId } = useParams();
  const [choosing, setChoosing] = useState(false);
  const [page, setPage] = useState(1);
  const onSearchChange = useCallback((value: string) => { setSearch(value); setPage(1); }, []);
  const query = useFrontlineOrganizationsQuery({
    search,
    scope: 'frontline',
    page
  });
  return <VStack align="stretch" gap={6}>
    <PageHeader title="Frontline" subtitle="Manage practice phone assistants, inbox access and on-call coverage." onRefresh={() => void query.refetch()} isRefreshing={query.isFetching} onAddNew={() => {
      setChoosing(true);
    }} addButtonText="Set up an organization" />
    <SearchAndFiltersSection searchValue={search} searchPlaceholder="Search by organization name..." onSearchChange={onSearchChange} />
    {query.isError && <Text role="alert" color="red.600">Could not load organizations. <Button variant="ghost" onClick={() => void query.refetch()}>Retry</Button></Text>}
    <EntityTableSection data={query.currentData?.data ?? []} isLoading={query.isFetching} keyExtractor={org => org.id} onRowClick={org => navigate(`/frontline/${org.id}`)} columns={[{
      key: 'name',
      title: 'Organization',
      variant: 'primary'
    }, {
      key: 'enabled',
      title: 'Dashboard inbox',
      render: org => <Badge colorPalette={org.enabled ? 'green' : 'gray'}>{org.enabled ? 'Enabled' : 'Disabled'}</Badge>
    }, {
      key: 'activePhoneCount',
      title: 'Active numbers'
    }, {
      key: 'timezone',
      title: 'Timezone'
    }, {
      key: 'setup',
      title: '',
      render: org => <Button size="sm" variant="outline" onClick={() => navigate(`/frontline/${org.id}`)}>Manage setup</Button>
    }]} emptyState={{
      icon: Phone,
      title: 'No Frontline organizations',
      description: 'Choose “Set up an organization” to configure a practice.'
    }} />
    {query.currentData && <Pagination paginationInfo={query.currentData} onPageChange={setPage} showPageSizeSelector={false} isLoading={query.isFetching} />}
    {(choosing || organizationId) && <FrontlineSetupDrawer organizationId={organizationId} onSelect={id => { setChoosing(false); navigate(`/frontline/${id}`); }} onClose={() => { setChoosing(false); navigate('/frontline'); }} />}
  </VStack>;
}
